import styled from "styled-components";
import {Container} from "../../components/UI";

export const Styled = {
    Wrapper: styled(Container)`
        padding-top: 50px;
        padding-bottom: 50px;
        
        display: flex;
        justify-content: center;
    `
}